import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { InsuranceProviderService } from "../InsuranceProviderService/insuranceProvider.service";
import { InsuranceProviderDelegate } from "../InsuranceProviderService/insuranceProvider.delegate";
export class InsuranceProviderServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): InsuranceProviderService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new InsuranceProviderDelegate(config, httpProvider);

        return new InsuranceProviderService(delegate, authenticationService);
    }
}